module.exports = __webpack_public_path__ + "img/cotoclub5.df296592.png";